import { connect } from 'react-redux';
import Notification from '../component/notification/Notification';
import actions from '../redux/actions/notification';

const mapStateToProps = (state) => ({
  coin: state.setting.coinSettings,
  notification: state.notification.notification,
});

const mapDispatchToProps = (dispatch) => ({
  fetchNotifications: (params, callback) => {
    dispatch(actions.fetchNotification(params, callback));
  },
  addNotifications: (params, callback) => {
    dispatch(actions.addNotification(params, callback));
  },
  updateNotifications: (params, callback) => {
    dispatch(actions.updateNotification(params, callback));
  },
  deleteNotifications: (params, callback) => {
    dispatch(actions.deleteNotification(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
